
import * as ActionTypes from 'constants';

export const features = (state = {
	fetching_features : false,
	open_features : [],
	features_list : [],
	features_tree : [],
	features_owner_type : '',
}, action) => {

	let {type, payload} = action;
	let index;

	switch(type) {
		case ActionTypes.TOGGLE_SHOW_FEATURE :
			index = state.open_features.findIndex(f => f === payload)

			if(index === -1)
				return {...state, open_features : [...state.open_features , payload]}
			else
				return {...state, open_features : state.open_features.filter((f,i) => i !== index)}

		case ActionTypes.CLEAR_SHOW_FEATURE :
			return {...state, open_features : []}

		case ActionTypes.UPDATE_FEATURES_LIST :
			return {...state, features_list : payload}
		case ActionTypes.UPDATE_FEATURES_TREE :
			return {...state, features_tree : payload}
		case ActionTypes.UPDATE_FEATURES_OWNER :
			return {...state, features_owner_type : payload}
		case ActionTypes.TOGGLE_FETCHING_FEATURES :
			return {...state, fetching_features : payload !== undefined ? payload : !state.fetching_features}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/features.js